
import { createSelector } from 'reselect';

const getVersion = state => state.config.version;

export const versionSelector = createSelector(getVersion, state => state);